module.exports = __webpack_public_path__ + "img/191.a1cdb17f.jpg";